Vue.component("profile", {
  props: {
    profileStateData: {
      type: Object
    },
    selectedData: {
      type: Object
    },
    selectedData: {
      type: Object
    },
    tableRows: {
      type: Object
    },
    featured: {
      type: Array
    },
    districtdata: {
      type: Object
    },
    staffingData: {
      type: Array
    },
    staffingData17: {
      type: Array
    },
    sortedData: {
      type: Array
    },
    haslegend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      forecast: false,
      dataformat: "percent",
      isloaded: true,
      hastable: "1",
      title: "TITLE!!"
    };
  },
  methods: {
    resetProfiles() {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("saved")) {
        window.location = window.location.href.split("?")[0];
        return;
      }
      document.getElementById("interactive-filters").classList.remove("hidden");
      document.getElementById("interactive-filters").classList.remove("closed");
      window.scrollTo(0, 0);
    }
  }
});
